import { Component, OnInit } from '@angular/core';
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";

@Component({
  selector: 'app-add-note',
  templateUrl: './add-note.component.html',
  styleUrls: ['./add-note.component.scss']
})
export class AddNoteComponent implements OnInit {
  public noteContent: string = "";
  constructor(
    private ref: DynamicDialogRef,
    private config: DynamicDialogConfig,

) {
    if (this.config.data != undefined) {
      this.noteContent = this.config.data.note;
    }
  }

  ngOnInit(): void {
  }
  add() {
    this.ref.close(this.noteContent);
  }

}
